import {
  suppliersDetailsTranslation,
  SuppliersDetailsTranslation,
} from '@/assets/locales/views/suppliers/details/suppliers.details.translation.pl.ts';
import {
  SuppliersListTranslation,
  suppliersListTranslation,
} from '@/assets/locales/views/suppliers/list/suppliers.list.translation.pl.ts';

export type SuppliersTranslation = {
  details: SuppliersDetailsTranslation;
  list: SuppliersListTranslation;
};

export const suppliersTranslation: SuppliersTranslation = {
  details: suppliersDetailsTranslation,
  list: suppliersListTranslation,
};
